module.exports = __webpack_public_path__ + "img/topicProgress.6bad3aca.svg";